import { gameAction } from "_actions";
import { GameService } from "_services";
import React, { useEffect, useState } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import ScrollableListView from "../ScrollableListView";
import { Helmet } from "react-helmet";
import { useParams, useLocation } from "react-router-dom";
import { de } from "date-fns/locale";
import { isBrowser, isMobile, isTablet } from "react-device-detect";
import { detroidVirtualGames } from "BaseServiceURLs";
import { detroidGames } from "BaseServiceURLs";
import Footer from "../Home/Footer";
import { gamesGameTypes } from "BaseServiceURLs";
import { tvBetGameTypes } from "BaseServiceURLs";
import { virtualGameTypes } from "BaseServiceURLs";
import { SiteFeatures } from "config/siteFeatures";
import { isProviderKeyAllowed, getSortedAllowedProviderKeys } from "./FilterSearch";

/*

['TABLE_GAMES', 'SLOT', 'SCRATCH', 'VIRTUAL', 'INSTANT', 'CRASH', 'LOTTERY']
['CSGI', 'CSIM', 'ZEUS', 'CSGG', 'KNTC', 'VGRG', undefined] 
['MOBILE','DESKTOP']

*/

const Casino = (props) => {
  let params = GetParams();
  const location = useLocation();

  function GetParams() {
    let params = useParams();
    return params;
  }
  const { user, loggedIn, sports, games, allGames, UpdateGames } = props;
  const [loading, setLoading] = useState(false);
  const [currentProvider, setCurrentProvider] = useState(!SiteFeatures.CLOSED_SYSTEM ? "pragmatic_innova" : "");
  const [selectedProviders, setSelectedProviders] = useState(!SiteFeatures.CLOSED_SYSTEM ? ["pragmatic_innova"] : []);
  const [FilterSearchValue, setFilterSearchValue] = useState("");

  // Provider seçimini localStorage'da saklama için key'ler. Hesaba özel (userIdentity)
  // saklanır ki aynı tarayıcıda farklı bir hesaba giriş yapıldığında önceki hesabın
  // seçimi yeni hesaba sızmasın. Logout'ta authentication.user her zaman null olduğu
  // için (bkz. authentication.reducer.js LOGOUT case) misafir durumu güvenle ayrışır.
  const userIdentity = user && user._id ? user._id : "guest";
  const getProviderKey = () => `current_provider_${userIdentity}_${location.pathname}`;
  const getSelectedProvidersKey = () => `selected_providers_${userIdentity}_${location.pathname}`;

  useEffect(() => {
    getGames();
  }, []);

  // Provider hafızası: kaydedilmiş seçim geri yüklenir, ama yetki durumu her zaman
  // önceliklidir. games/permissions/loggedIn/userIdentity her değiştiğinde (login,
  // logout, hesap değişimi, yetki güncellemesi) hafızadan gelen seçim tek doğruluk
  // kaynağı olan getSortedAllowedProviderKeys ile yeniden doğrulanır; artık izinli
  // olmayan ya da başka bir hesaba ait bir provider asla state'e yansımaz, bunun
  // yerine ilk izinli provider'a düşülür.
  useEffect(() => {
    if (!games || params.ProviderId) return;
    const allowed = getSortedAllowedProviderKeys(games, props.permissions, loggedIn);
    if (allowed.length === 0) return;

    const savedProvider = localStorage.getItem(getProviderKey());
    let savedSelected = [];
    try {
      const parsed = JSON.parse(localStorage.getItem(getSelectedProvidersKey()));
      if (Array.isArray(parsed)) savedSelected = parsed;
    } catch (error) {
      console.error('Error parsing saved selected providers:', error);
    }

    const validSelected = savedSelected.filter((p) => allowed.includes(p));
    const nextSelected = validSelected.length > 0 ? validSelected : [allowed[0]];
    const selectedChanged =
      nextSelected.length !== selectedProviders.length ||
      nextSelected.some((p, i) => p !== selectedProviders[i]);
    if (selectedChanged) {
      setSelectedProviders(nextSelected);
    }

    const nextCurrent =
      savedProvider && allowed.includes(savedProvider) ? savedProvider : nextSelected[0];
    if (currentProvider !== nextCurrent) {
      setCurrentProvider(nextCurrent);
    }
  }, [games, props.permissions, loggedIn, params.ProviderId, userIdentity, location.pathname]);

  useEffect(() => {
    setFilterSearchValue("");
    if (
      params.ProviderId &&
      isProviderKeyAllowed(params.ProviderId, games, props.permissions, loggedIn)
    ) {
      setCurrentProvider(params.ProviderId);
    }
  }, [params.ProviderId]);

  useEffect(() => {
    if (
      games &&
      params &&
      params.ProviderId &&
      games.hasOwnProperty(params.ProviderId) &&
      isProviderKeyAllowed(params.ProviderId, games, props.permissions, loggedIn)
    ) {
      setCurrentProvider(params.ProviderId);
    }
    try {
      if (games) {
        const _allGames = allGames;
        const aa = getFilterTimelessTech("live-casino");
      }
    } catch (error) { }
  }, [games, params.ProviderId]);

  const getFilterTimelessTech = (subtype, type) => {
    return Object.keys(games).filter((x) => {
      if (x.includes("timelesstech")) {
        return games[x].length > 0
          ? subtype
            ? games[x][0].subtype == subtype
            : true && subtype
              ? games[x][0].type == type
              : true
          : false;
      }
      return x.includes("timelesstech");
    });
  };

  const handleMultipleProviderSelect = (providers) => {
    setSelectedProviders(providers);
    // İlk seçili provider'ı current provider olarak ayarla (geriye uyumluluk için)
    if (providers.length > 0) {
      setCurrentProvider(providers[0]);
    }
  };

  // Provider değişikliklerini localStorage'a kaydet (hesaba özel key ile)
  useEffect(() => {
    if (currentProvider) {
      localStorage.setItem(getProviderKey(), currentProvider);
    }
  }, [currentProvider, location.pathname, userIdentity]);

  useEffect(() => {
    if (selectedProviders.length > 0) {
      localStorage.setItem(getSelectedProvidersKey(), JSON.stringify(selectedProviders));
    }
  }, [selectedProviders, location.pathname, userIdentity]);

  const getGames = async () => {
    setLoading(true);
    await GameService.GET_GAMES()
      .then((res) => {
        setLoading(false);

        const newData = res.map((x) => {
          let y = x;
          if (x.middleware == "blas975") {
            y.CacheData = x.CacheData.reverse();
            return y;
          } else {
            return x;
          }
        });

        UpdateGames(newData);
      })
      .catch((err) => {
        debugger;

        setLoading(false);
      });
  };
  const pb = require("../../../assets/img/banners/bg.jpg");
  const priorityPragmatic = ["94572", "108493", "108716", "93509", "108601", "108450", "108411", "89916", "93210", "", "108342", "94571", "94569", "94570", "93507", "93504", "93501", "93508", "93506", "108582", "89951", "108799"]
  return (
    <Translation>
      {(t) => (
        <>
          <Helmet>
            <title>{t("TITLE_CASINO")}</title>
          </Helmet>

          {games && (
            <div className={currentProvider}>
              <ScrollableListView
                FilterSearchValue={FilterSearchValue}
                setFilterSearchValue={setFilterSearchValue}
                pb={pb}
                title={t("TITLE_CASINO")}
                provider={currentProvider}
                setProvider={setCurrentProvider}
                selectedProviders={selectedProviders}
                setSelectedProviders={handleMultipleProviderSelect}
                data={
                  (games && (selectedProviders.length > 0 ?

                    // Çoklu provider seçimi varsa, tüm seçili provider'ların oyunlarını birleştir
                    selectedProviders.reduce((allGames, provider) => {
                      if (games.hasOwnProperty(provider) && isProviderKeyAllowed(provider, games, props.permissions, loggedIn)) {
                        let providerGames = [...games[provider]];
                        // Pragmatic provider için oyunları priorityPragmatic listesine göre sırala
                        if (provider === "pragmatic") {
                          providerGames = games[provider].sort((a, b) => {
                            // Oyun ID'lerini priorityPragmatic listesinde ara
                            const aIndex = priorityPragmatic.indexOf(a.id?.toString());
                            const bIndex = priorityPragmatic.indexOf(b.id?.toString());

                            // Her ikisi de öncelikli listede varsa, öncelik sırasına göre sırala
                            if (aIndex !== -1 && bIndex !== -1) {
                              return aIndex - bIndex;
                            }

                            // Sadece a öncelikli listede varsa, a önce gelsin
                            if (aIndex !== -1 && bIndex === -1) {
                              return -1;
                            }

                            // Sadece b öncelikli listede varsa, b önce gelsin
                            if (aIndex === -1 && bIndex !== -1) {
                              return 1;
                            }

                            // İkisi de öncelikli listede yoksa, ID'ye göre ters sırala
                            return (b.id || 0) - (a.id || 0);
                          });
                        }
                        return [...allGames, ...providerGames];
                      }
                      return allGames;
                    }, [])
                    : games.hasOwnProperty(currentProvider) &&
                      isProviderKeyAllowed(currentProvider, games, props.permissions, loggedIn)
                      ? (() => {
                        let providerGames = [...games[currentProvider]];
                        // Pragmatic provider için oyunları priorityPragmatic listesine göre sırala

                        if (currentProvider === "pragmatic") {
                          providerGames = providerGames.sort((a, b) => {
                            // Oyun ID'lerini priorityPragmatic listesinde ara
                            const aIndex = priorityPragmatic.indexOf(a.id?.toString());
                            const bIndex = priorityPragmatic.indexOf(b.id?.toString());

                            // Her ikisi de öncelikli listede varsa, öncelik sırasına göre sırala
                            if (aIndex !== -1 && bIndex !== -1) {
                              return aIndex - bIndex;
                            }

                            // Sadece a öncelikli listede varsa, a önce gelsin
                            if (aIndex !== -1 && bIndex === -1) {
                              return -1;
                            }

                            // Sadece b öncelikli listede varsa, b önce gelsin
                            if (aIndex === -1 && bIndex !== -1) {
                              return 1;
                            }

                            // İkisi de öncelikli listede yoksa, ID'ye göre ters sırala
                            return (b.id || 0) - (a.id || 0);
                          });
                        }

                        return providerGames;
                      })()
                      : []))
                    ?.filter((x) => {

                      switch (x._midleware) {
                        case 'matgame':
                          if (x.game_type === 1) {
                            return true;
                          }
                          return false;
                        case 'innova':
                          if (x.enabled === 1 && x.subtype !== 'crashgame' && x.subtype !== 'live-casino') {
                            return true;
                          }
                          return false;
                          break;
                        case 'gasea':
                          if (x.categoryCode.toLowerCase().includes('slots')) {
                            return true;
                          }
                          return false;
                          break;
                        default:
                          return true;
                          break;
                      }

                    })
                    .filter((x) => {
                      //   debugger;
                      if (
                        (params.ProviderId
                          ? params.ProviderId
                          : currentProvider).includes('-fundist')
                      ) {
                        if (x.Trans) {
                          const _n = x.Trans.hasOwnProperty(t("LANG"))
                            ? x.Trans[t("LANG")]
                            : x.Trans.en;

                          return _n
                            .toLocaleLowerCase()
                            .includes(
                              FilterSearchValue?.toLocaleLowerCase()
                            );
                        } else {
                          debugger;
                        }
                      } else {
                        let _val = (params.ProviderId
                          ? params.ProviderId
                          : currentProvider) == "pragmatic-casino"
                          ? "gameName"
                          : currentProvider == "smartsoft"
                            ? "Name"
                            : (currentProvider.includes('timeless') || currentProvider.includes('timeless'))
                              ? "title"
                              : "name";
                        if (x._midleware == 'innova') {
                          _val = 'title';
                        }
                        if (x._midleware == 'gasea') {
                          _val = 'title';
                        }
                        if (x._midleware == 'matgame') {
                          _val = 'name';
                        }

                        const __XXX = x[_val]
                          ?.toLocaleLowerCase()
                          .includes(FilterSearchValue?.toLocaleLowerCase());
                        return __XXX
                      }
                    })
                    .filter((x) => {
                      if (
                        (params.ProviderId
                          ? params.ProviderId
                          : currentProvider) == "pragmatic-casino"
                      ) {
                        return (
                          x.gameTypeID != "lg" && x.gameTypeID != "rgs-vsb"
                        );
                      } else if (
                        (params.ProviderId
                          ? params.ProviderId
                          : currentProvider) == "iconix"
                      ) {
                        return x.type == "slots";
                      } else if (
                        (params.ProviderId
                          ? params.ProviderId
                          : currentProvider).includes('-fundist')
                      ) {
                        if (isMobile && x.MobilePageCode) {
                          return true;
                        }
                        if (!isMobile && x.PageCode) {
                          return true;
                        }
                        return false;
                      } else if (
                        isMobile &&
                        (x.provider == "CSGI" ||
                          x.provider == "CSIM" ||
                          x.provider == "ZEUS" ||
                          x.provider == "CSGG" ||
                          x.provider == "KNTC" ||
                          x.provider == "VGRG")
                      ) {
                        if (x.platforms?.find((x) => x == "MOBILE")) {
                          return true;
                        } else {
                          return false;
                        }
                      } else {
                        return true;
                      }
                    })
                    .filter((x) => {
                      let _virtuals = [];
                      [...detroidVirtualGames, ...detroidGames].forEach(
                        (i) => {
                          _virtuals = [..._virtuals, ...i.data];
                        }
                      );
                      if (x.gamecode) {
                        if (_virtuals.find((v) => v == x.gamecode)) {
                          return false;
                        }
                      }
                      return true;
                    }).filter((x) => {
                      /*
                       if (user?.Currency == 'TRY') {
                         return true;
                       }*/
                      if (x._midleware == "innova") {
                        return true;
                      }
                      return true; // PARA KONTROLÜ İPTAL
                      const userCurrency = user?.Currency?.toString()?.toUpperCase?.();
                      if (!userCurrency) return true;
                      const currencies = Array.isArray(x?._currencies) ? x._currencies : [];
                      return currencies.some((currency) => (currency ?? "").toString().toUpperCase() === userCurrency);
                    }).filter(x => {
                      if (x._midleware == "innova") {
                        if (gamesGameTypes.some(y => y == x.type)) {
                          return false;
                        } else if (virtualGameTypes.some(y => y == x.type)) {
                          return false;
                        } else if (tvBetGameTypes.some(y => y == x.type)) {
                          return false;
                        }
                      }
                      return true;

                    }).sort((a, b) => {
                      const aMatch = a._midleware === 'innova' && a.vendor === 'pragmatic';
                      const bMatch = b._midleware === 'innova' && b.vendor === 'pragmatic';

                      // İkisi de eşleşiyorsa → sırala
                      if (aMatch && bMatch) {
                        return b.id - a.id;
                      }

                      // Sadece biri eşleşiyorsa → onu üste al (opsiyonel)
                      if (aMatch) return -1;
                      if (bMatch) return 1;

                      // nonameHero ise id_game'e göre büyükten küçüğe sırala
                      if (a._midleware === 'nonameHero' && b._midleware === 'nonameHero') {
                        return (b.id_game || 0) - (a.id_game || 0);
                      }

                      // Hiçbiri eşleşmiyorsa → dokunma
                      return 0;
                    }) || []
                }
              />

              <Footer />

            </div>
          )}
        </>
      )}
    </Translation>
  );
};
/*

                            .reverse()
                            .sort((a, b) =>
                              a.gameIdNumeric > b.gameIdNumeric ? -1 : 1
                            )
*/
const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, permissions, permissionsAll } = authentication;
  const { sports, games, allGames } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    allGames,
    permissions,
    permissionsAll,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateGames: (data) => dispatch(gameAction.UpdateGamesData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Casino);
